import { StandardEvents } from '@shopify/events';

class CorkMartVariantTable extends HTMLElement {
  #controller;
  #generation = 0;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    document.addEventListener(StandardEvents.productSelect, this.onVariant, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    ++this.#generation;
  }

  onVariant = async (event) => {
    if (event.target.closest('product-card, quick-add-dialog')) return;
    const generation = ++this.#generation;
    try {
      const { detail } = await event.promise;
      if (generation !== this.#generation || !this.isConnected || String(detail.productId) !== this.dataset.productId) return;
      const selectedId = String(detail.resource?.id || '');
      for (const row of this.querySelectorAll('tbody tr[data-variant-id]')) {
        const current = row.dataset.variantId === selectedId;
        row.classList.toggle('is-current', current);
        const link = row.querySelector('th a');
        if (current) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      }
    } catch {
      return;
    }
  };
}

if (!customElements.get('cm-variant-table')) customElements.define('cm-variant-table', CorkMartVariantTable);
